// extracted by mini-css-extract-plugin
module.exports = {"parallaxSection":"ParallaxSection-module--parallaxSection--34ONO","topText":"ParallaxSection-module--topText--QyWsL"};